import React from "react";
import { Modal, Box, Typography, Button } from "@mui/material";

interface SessionExpiredModalProps {
  open: boolean; // Use 'open' as the prop name
  onClose: () => void;
}

const SessionExpiredModal: React.FC<SessionExpiredModalProps> = ({ open, onClose }) => {
  return (
    <Modal open={open} onClose={onClose} aria-labelledby="session-expired-modal">
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          bgcolor: "background.paper",
          boxShadow: 24,
          p: 4,
          borderRadius: 2,
        }}
      >
        <Typography id="session-expired-modal" variant="h6" component="h2">
          Session Expired
        </Typography>
        <Typography sx={{ mt: 2 }}>
          Your session has expired. Please log in again to continue.
        </Typography>
        <Button
          variant="contained"
          sx={{ mt: 2 }}
          onClick={onClose}
        >
          Log In Again
        </Button>
      </Box>
    </Modal>
  );
};

export default SessionExpiredModal;
